import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import InternetLimitViewModel from '../ViewModels/InternetLimitViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IInternetLimitDropDownProps {
    setInternetLimit?: (event) => void;
    internetLimit: string | undefined;
    disabled: boolean;
    mobileInternet: boolean;
}

interface IInternetLimitDropDownState {
    model: InternetLimitViewModel[];
    loaded: boolean;
}

class InternetLimitDropDown extends Component<IInternetLimitDropDownProps & WithStyles<typeof styles>, IInternetLimitDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetInternetLimits').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultInternetLimitVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label="Please select the option that fits closest to the data allowance or limit *"
                name={this.props.mobileInternet ? "mobileInternetDataLimitValue" : "homeInternetDataLimitValue"}
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.internetLimit}
                onChange={this.props.disabled ? undefined : this.props.setInternetLimit}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(InternetLimitDropDown);